import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-line-semantics-time-series-intent',
  templateUrl: './line-semantics-time-series-intent.component.html',
  styleUrl: './line-semantics-time-series-intent.component.scss',
})
export class LineSemanticsTimeSeriesIntentComponent {
  isLoading = true;
  label: any = {
    show: true,
    position: 'inside',
    formatter: (params) =>
      params.value >= 5 ? parseInt(params.value) + '%' : '',
    fontWeight: 'bold',
    color: '#fff',
  };

  options: echarts.EChartsOption = {
    grid: { left: 20, right: 30, top: 40, bottom: 80 },
    stack: 'total',
    yAxis: {
      max: 100,
      axisLabel: {
        formatter: '{value}%', // append percentage sign to labels
      },
    },
    series: [
      {
        type: 'bar',
        stack: 'total',
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
    ],
  };

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.semanticsTimeSeriesIntent$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('semanticsTimeSeriesIntent');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getSemanticsTimeSeriesIntent().subscribe();
  }

  get series() {
    return this.analyticsService.semanticsTimeSeriesIntent$.value?.series;
  }

  get labels() {
    return this.analyticsService.semanticsTimeSeriesIntent$.value?.labels;
  }
}
